export class CollapsableDef {
    public Collapsable: string;
    public TranslationKey: string | null = null;

    public constructor(collapsable: string, translationKey: string | null) {
        this.Collapsable = collapsable;
        this.TranslationKey = translationKey;
    }
}
